import React from 'react';
import PropTypes from 'prop-types';
import { optimiseImage } from 'src/common/utils/prismic-image';
import Options from './Options';
import './CountryToggle.scss';

export const CountryToggle = props => (
  <div className="country-toggle" >
    <button
      className="country-toggle-pill"
      type="button"
      onClick={props.handleCountryClick}>
      <img
        src={optimiseImage(props.country.flag.url, {
          auto: 'format,compress',
          w: props.country.flag.width,
        })}
        alt={props.country.iso}
        width="30"
        className="country-toggle-image"
      />{' '}
      <span className="country-toggle-text">{props.country.name}</span>
    </button>
    {props.isOpen && (
      <Options
        for="country"
        countries={props.countries}
        currentValue={props.country}
        open={props.isOpen}
        title={props.countryHeading}
        onClose={props.handleCountryClick}
      />
    )}
  </div>
);

CountryToggle.propTypes = {
  country: PropTypes.shape({
    flag: PropTypes.object.isRequired,
    iso: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  countries: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  countryHeading: PropTypes.string.isRequired,
  handleCountryClick: PropTypes.func.isRequired,
};

export default CountryToggle;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/CountryToggle/CountryToggle.js